export default {
  backgroundColor: '#eee',
  border: 'none',
  borderRadius: 6,
  height: 120,
  marginRight: 12,
  width: 120,
};
